import { createFileRoute } from '@tanstack/react-router'

import { OutletFormPage } from '@/features/outlet/components/outlet-form-page'

import type { CrumbLoader } from '@/hook/use-breadcrumbs'

export const Route = createFileRoute('/_app/settings/outlet/create')({
  component: Component,
  loader: () => {
    return {
      crumb: 'Tambah Outlet',
    } as CrumbLoader
  },
})

function Component() {
  const navigate = Route.useNavigate()
  const onBack = () => navigate({ to: '/settings/outlet', replace: true })

  return <OutletFormPage onBack={onBack} mode='create' />
}
